<template>
  <el-tooltip
    class="item"
    effect="dark"
    :content="show ? '点击隐藏' + content : '点击显示' + content"
    placement="right"
  >
    <div
      class="btn-show-wrap"
      @click="bindShow"
      :style="{
        background: isIE()
          ? 'rgba(188, 188, 188, 0.49)'
          : 'rgba(188, 188, 188, 0.38)',
      }"
    >
      <span v-if="isIE()" class="collapse_before"></span>
      <i
        :class="{ 'el-icon-caret-left': show, 'el-icon-caret-right': !show }"
      ></i>
      <span v-if="isIE()" class="collapse_after"></span>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    /*判断是否是IE*/
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return true;
      } else {
        return false;
      }
    },
    bindShow() {
      this.show = !this.show;
      this.$emit("show");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-show-wrap {
  position: absolute;
  top: 50%;
  left: 0px;
  z-index: 99;
  width: 16px;
  background: #bcbcbc60;
  padding: 10px 0px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.btn-show-wrap:before,
.btn-show-wrap:after,
.collapse_before,
.collapse_after {
  position: absolute;
  content: "";
}
.btn-show-wrap:before,
.collapse_before {
  left: 0px;
  top: 36px;
  border-right: 16px transparent dashed;
  border-top: 16px rgba(188, 188, 188, 0.38) solid;
}
.btn-show-wrap:after,
.collapse_after {
  left: 0px;
  top: -16px;
  border-top: 16px transparent dashed;
  border-left: 16px rgba(188, 188, 188, 0.38) solid;
}
.collapse_before,
.collapse_after {
 // border-right: 16px rgba(188, 188, 188, 0.18) solid;
}
</style>